module.exports = __webpack_public_path__ + "static/media/cricle-location.14cf929d.svg";